import { render } from "./newsDetails.vue?vue&type=template&id=1e74ce3a&scoped=true"
import script from "./newsDetails.vue?vue&type=script&lang=js"
export * from "./newsDetails.vue?vue&type=script&lang=js"

import "./newsDetails.vue?vue&type=style&index=0&id=1e74ce3a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e74ce3a"]])

export default __exports__